import Recat from 'react'
import {Component} from 'react'

import {Card, Button, Nav} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

function Display(props) {
  return (
    <Card style={{ width: '18rem' }} className="text-center">
      <Card.Img variant="top" src={props.source} />
      <Card.Body>
        <Card.Title>{props.name}</Card.Title>
        <Card.Text style={{fontWeight: "300"}}>
        {props.desc}
        </Card.Text>
        <Button variant="info" href={props.addr}>Let's Go!</Button>
      </Card.Body>
    </Card>
  );
}

export default Display;
